import React, { useContext, useEffect, useState } from 'react'
import { Context } from '../../Context/Context'

function ClientDetails({data, setShowEdit, hideBtn}) {
  const {userDetails} = useContext(Context);
  useEffect(() => {
    if(data)
    {
      setUserData(data);
    }
    else
    {
      setUserData(userDetails);
    }
  },[userDetails,data])

  
    const [userData, setUserData] = useState(userDetails);

    const Field = ({label, value}) => (
      <div>
        <div style={{font:"400 10px/1 'IBM Plex Mono',monospace", letterSpacing:'.1em', textTransform:'uppercase', color:'rgba(20,33,61,.4)', marginBottom:'6px'}}>{label}</div>
        {value ?
          <div style={{font:"400 16px/1.3 'Spectral',serif", color:'#14213d'}}>{value}</div>
          :
          <div style={{font:"400 16px/1.3 'Spectral',serif", color:'rgba(20,33,61,.35)'}}>Not provided</div>
        }
      </div>
    )

  return (
    <div className='w-full font-plexsans bg-white'>
      <h2 style={{margin:'0 0 22px', font:"400 22px/1.25 'Spectral',serif", color:'#14213d'}}>Your profile</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-5 mb-7">
        <Field label="Name" value={(userData?.firstName || userData?.lastName) ? (userData?.firstName + " " + userData?.lastName) : null}/>
        <Field label="Age" value={userData?.age}/>
        <Field label="Email" value={userData?.email}/>
        <Field label="Phone" value={userData?.phoneNumber}/>
        <Field label="City" value={userData?.city}/>
        <Field label="State" value={userData?.state}/>
      </div>
      { !hideBtn &&
      <button
      className="cursor-pointer rounded-sm transition-colors"
      style={{font:"500 12.5px/1 'IBM Plex Sans',sans-serif", color:'#fffdf8', background:'#8a6231', border:'none', padding:'12px 22px'}}
      onMouseEnter={(e) => e.currentTarget.style.background = '#6d4c25'}
      onMouseLeave={(e) => e.currentTarget.style.background = '#8a6231'}
      onClick = {()=> setShowEdit(true)}>Edit profile</button>
    }
    </div>
  )
}

export default ClientDetails
